// UI1d: after the filter form saves, the list reloads only if the filter edited is the one in use
export function editedFilterIsCurrent(filterToEdit, savedFilter) {
  return !!(filterToEdit && filterToEdit.id && savedFilter && filterToEdit.id === savedFilter.id)
}
